import materialsItem from "@components/ui-components/materials-item/component.js";

export default {
    data() {
        return {

        }
    },
    components: {
        'materials-item-cmp': materialsItem,
    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/materials/component.js